import { API_JWT_BASE_URL } from '../http'

export const GROUP_CONFIGURATION_API = `${API_JWT_BASE_URL}/GroupConfigurations/`
export const APPROVE_GROUP_API = `${API_JWT_BASE_URL}/GroupConfigurations/approve`
export const GET_ERROR_LOG_API = `${API_JWT_BASE_URL}/GroupConfigurations/errordetailslog`
export const VALIDATE_APPROVAL = `${API_JWT_BASE_URL}/GroupConfigurations/validateapproval`

export const GROUP_CONFIGURATION_QUERY_KEYS = {
  APPROVE_GROUP: 'approveGroup',
  GET_ERROR_LOG: 'getErrorLog',
  VALIDATE_APPROVAL: 'validateapproval',
  GROUP_CONFIGURATION: 'GROUP_CONFIGURATION'
}
